/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetTypeV2FormConfigModel } from './PetTypeV2FormConfigModel';
import {
    PetTypeV2FormConfigModelFromJSON,
    PetTypeV2FormConfigModelFromJSONTyped,
    PetTypeV2FormConfigModelToJSON,
} from './PetTypeV2FormConfigModel';

/**
 * 
 * @export
 * @interface PetFormFieldValueTypeV2Model
 */
export interface PetFormFieldValueTypeV2Model {
    /**
     * 
     * @type {string}
     * @memberof PetFormFieldValueTypeV2Model
     */
    type: PetFormFieldValueTypeV2ModelTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PetFormFieldValueTypeV2Model
     */
    isSelected: boolean;
    /**
     * 
     * @type {string}
     * @memberof PetFormFieldValueTypeV2Model
     */
    display?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetFormFieldValueTypeV2Model
     */
    isDefault: boolean;
    /**
     * 
     * @type {number}
     * @memberof PetFormFieldValueTypeV2Model
     */
    order: number;
    /**
     * 
     * @type {PetTypeV2FormConfigModel}
     * @memberof PetFormFieldValueTypeV2Model
     */
    value?: PetTypeV2FormConfigModel;
    /**
     * 
     * @type {Array<PetFormFieldValueTypeV2Model>}
     * @memberof PetFormFieldValueTypeV2Model
     */
    values?: Array<PetFormFieldValueTypeV2Model>;
}


/**
 * @export
 */
export const PetFormFieldValueTypeV2ModelTypeEnum = {
    PetType: 'PetType',
    Breed: 'Breed',
    GenderAndSterilization: 'GenderAndSterilization',
    Medication: 'Medication',
    MedicationAllergy: 'MedicationAllergy',
    HealthCondition: 'HealthCondition',
    RidingStyles: 'RidingStyles',
    PrimaryDiscipline: 'PrimaryDiscipline'
} as const;
export type PetFormFieldValueTypeV2ModelTypeEnum = typeof PetFormFieldValueTypeV2ModelTypeEnum[keyof typeof PetFormFieldValueTypeV2ModelTypeEnum];


/**
 * Check if a given object implements the PetFormFieldValueTypeV2Model interface.
 */
export function instanceOfPetFormFieldValueTypeV2Model(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "isSelected" in value;
    isInstance = isInstance && "isDefault" in value;
    isInstance = isInstance && "order" in value;

    return isInstance;
}

export function PetFormFieldValueTypeV2ModelFromJSON(json: any): PetFormFieldValueTypeV2Model {
    return PetFormFieldValueTypeV2ModelFromJSONTyped(json, false);
}

export function PetFormFieldValueTypeV2ModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormFieldValueTypeV2Model {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'isSelected': json['isSelected'],
        'display': !exists(json, 'display') ? undefined : json['display'],
        'isDefault': json['isDefault'],
        'order': json['order'],
        'value': !exists(json, 'value') ? undefined : PetTypeV2FormConfigModelFromJSON(json['value']),
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(PetFormFieldValueTypeV2ModelFromJSON)),
    };
}

export function PetFormFieldValueTypeV2ModelToJSON(value?: PetFormFieldValueTypeV2Model | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'isSelected': value.isSelected,
        'display': value.display,
        'isDefault': value.isDefault,
        'order': value.order,
        'value': PetTypeV2FormConfigModelToJSON(value.value),
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(PetFormFieldValueTypeV2ModelToJSON)),
    };
}

